module.exports = __webpack_public_path__ + "static/img/Jarryd-Hayne.f09d767.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jarryd-Hayne.jpg
// module id = 0xBU
// module chunks = 0